import { useState } from "react";
//import { onMessageListener } from "services/firebase/firebaseUtil";
import { MoveToZoomDialog } from "./components/MoveToZoomDialog/MoveToZoomDialog";

export function PushNotification() {
  const [showMoveToZoom, setShowMoveToZoom] = useState(false);
  const [notification, setNotification] = useState<{ [key: string]: string }>({});

  // onMessageListener()?.then((payload) => {
  //   const data = JSON.parse(payload.data.data);
  //   if (payload.data.type === "lesson_session_switched_to_zoom") {
  //     setShowMoveToZoom(true);
  //     setNotification({
  //       lessonId: data.id,
  //       teacher: `${data.instructor.first_name} ${data.instructor.last_name}`,
  //     });
  //   }
  //   if (payload.data.type === "lesson_session_switched_to_zoom_video") {
  //     setShowMoveToZoom(true);
  //     setNotification({
  //       lessonId: data.id,
  //       teacher: `${data.instructor.first_name} ${data.instructor.last_name}`,
  //     });
  //   }
  // });

  const handleCloseMoveToZoom = () => {
    setShowMoveToZoom(false);
    setNotification({});
  };

  return (
    <>
      {showMoveToZoom && (
        <MoveToZoomDialog
          isOpen={showMoveToZoom}
          onClose={handleCloseMoveToZoom}
          lessonId={notification.lessonId}
          teacherName={notification.teacher}
        />
      )}
    </>
  );
}
